// export const componentPaths = {
//     "Camera": "camera",
//     "Shape": "shape"
// } as const;

export { default as Camera } from "./camera";
export { default as Shape } from "./shape";
export { default as Transform } from "../transform";
export { default as Label } from "./label";
export { default as Image } from "./image";